import { render, staticRenderFns } from "./TripAdvisorPreview.vue?vue&type=template&id=47cc7994&scoped=true"
import script from "./TripAdvisorPreview.vue?vue&type=script&lang=js"
export * from "./TripAdvisorPreview.vue?vue&type=script&lang=js"
import style0 from "./TripAdvisorPreview.vue?vue&type=style&index=0&id=47cc7994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47cc7994",
  null
  
)

export default component.exports